import { produce } from 'immer';
import { unionBy } from 'lodash-es';
import { ScopedAsyncType } from './scoped-type';
import { asyncAction } from './async-action';
import * as service from '../../services/deere-service';

const AsyncType = ScopedAsyncType('DEERE');

const SLICE = 'deere';

const LOAD_GROWER_ORGANIZATION = AsyncType('LOAD_GROWER_ORGANIZATION');
const LOAD_ORGANIZATION_FIELDS = AsyncType('LOAD_ORGANIZATION_FIELDS');
const LOAD_ORGANIZATION_OPERATIONS = AsyncType('LOAD_ORGANIZATION_OPERATIONS');

export const selectors = {
  selectedOrganization: (state) => state[SLICE].organization,
  fields: (state) => state[SLICE].fields || [],
  operations: (state) => state[SLICE].operations || [],
  isLoading: (state) => state[SLICE].isLoading,
};

export const actions = {
  loadGrowerOrganization,
  loadOrganizationFields,
  loadOrganizationOperations,
};

export const reducerHandlers = {
  [LOAD_GROWER_ORGANIZATION.start]: reduceLoadGrowerOrganizationStart,
  [LOAD_GROWER_ORGANIZATION.complete]: reduceLoadGrowerOrganizationComplete,
  [LOAD_GROWER_ORGANIZATION.failure]: reduceLoadGrowerOrganizationFailure,
  [LOAD_ORGANIZATION_FIELDS.start]: reduceLoadOrganizationFieldsStart,
  [LOAD_ORGANIZATION_FIELDS.complete]: reduceLoadOrganizationFieldsComplete,
  [LOAD_ORGANIZATION_FIELDS.failure]: reduceLoadOrganizationFieldsFailure,
  [LOAD_ORGANIZATION_OPERATIONS.start]: reduceLoadOrganizationOperationsStart,
  [LOAD_ORGANIZATION_OPERATIONS.complete]:
    reduceLoadOrganizationOperationsComplete,
  [LOAD_ORGANIZATION_OPERATIONS.failure]:
    reduceLoadOrganizationOperationsFailure,
};

function loadGrowerOrganization(growerId) {
  return asyncAction(LOAD_GROWER_ORGANIZATION, () =>
    service.getGrowerOrganization(growerId),
  );
}

function loadOrganizationFields(growerId, organizationId) {
  return asyncAction(LOAD_ORGANIZATION_FIELDS, () =>
    service.getOrganizationFields(growerId, organizationId),
  );
}

function loadOrganizationOperations(growerId, organizationId) {
  return asyncAction(LOAD_ORGANIZATION_OPERATIONS, () =>
    service.getOrganizationOperations(growerId, organizationId),
  );
}

function reduceLoadGrowerOrganizationStart(state) {
  state.isLoading = true;
  state.organization = null;
  state.fields = [];
}

function reduceLoadGrowerOrganizationComplete(state, payload) {
  state.organization = payload;
  state.isLoading = false;
  state.fields = [];
}

function reduceLoadGrowerOrganizationFailure(state) {
  state.organization = null;
  state.isLoading = false;
}

function reduceLoadOrganizationFieldsStart(state) {
  state.isLoading = true;
}

function reduceLoadOrganizationFieldsComplete(state, payload) {
  state.fields = unionBy(payload, state.fields, 'id');
  state.isLoading = false;
}

function reduceLoadOrganizationFieldsFailure(state) {
  state.isLoading = false;
}

function reduceLoadOrganizationOperationsStart(state) {
  state.isLoading = true;
}

function reduceLoadOrganizationOperationsComplete(state, payload) {
  state.operations = unionBy(payload, state.operations, 'id');
  state.isLoading = false;
}

function reduceLoadOrganizationOperationsFailure(state) {
  state.isLoading = false;
}

export const reducers = {
  [SLICE]: (state = {}, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};
